<div class="d-flex align-items-center justify-content-between mb-4 mx-xl-3">
    <h6 class="montserrat-medium text-gray-500">Define your product schedules</h6>
    <button class="btn btn-lg btn-gray-500" *ngIf="!shouldDisableAllPointers" (click)="navigateNextStep()"
        [disabled]="areSchedulesInvalid()">
        proceed
    </button>
</div>
<app-highlights *ngIf="campaign" [campaign]="campaign" [step]="3"></app-highlights>
<div class="d-xl-flex align-items-start justify-content-between">
    <div style="display: flex; flex-direction: column; width: 100%">
        <div [formGroup]="form">
            <div *ngIf="showChannelStatusDistinction() && campaign != undefined" class="accordion">
                <div *ngFor="let section of sections; let idx = index">
                    <div style="padding: 0 1.5rem 0 1.5rem">
                        <div class="header" (click)="toggleSection(idx)">
                            {{ section.title }}
                            <mat-icon style="transition: transform 0.3s ease; display: inline-block"
                                [ngClass]="{ 'rotate-arrow': section.open }">keyboard_arrow_down</mat-icon>
                        </div>
                    </div>
                    <div class="content" *ngIf="section.open">
                        <div [formArrayName]="section.content.formName">
                            <div *ngFor="
                                    let schedule of section.content.formValue?.controls;
                                    index as i;
                                    first as isFirst;
                                    last as isLast
                                " [formGroupName]="i" class="flex-grow-1 mx-xl-3 bg-gray-200 br-15 p-3 mb-4">
                                <app-channel-selection-field
                                    [control]="form.get([section.content.formName, i, 'channels'])" [channels]="
                                        filterAvailableChannelsByStatus(section.content.formName)
                                    " [scheduleChannels]="
                                        getScheduleChannels(i, section.content.formName)
                                    " [disabledChannelIds]="
                                        getDisabledChannelIds(
                                            i,
                                            section.content.formName,
                                            section.previewMode
                                        )
                                    " [disabled]="shouldDisableAllPointers || section.previewMode"
                                    [previewMode]="previewMode" (selectionChange)="onScheduleChannelsChanged(i, $event)"
                                    (toggleAll)="toggleAllSelection(schedule.value, i)"
                                    (remove)="removeScheduleChannel(i, $event)" [customClass]="'col-12 col-lg-12'"
                                    [customStyle]="{ width: '50%' }"></app-channel-selection-field>

                                <div style="display: flex; flex-direction: row">
                                    <div style="width: 100%">
                                        <div class="bg-gray-200 br-15 py-3 mb-4" style="width: 100%">
                                            <div class="filters col-12 mb-4 border-bottom border-gray-300">
                                                <div class="row mb-4">
                                                    <div class="col-12 col-lg-6 mb-3 mb-lg-0">
                                                        <mat-form-field class="form-group dark-input" [ngClass]="{
                                                                validationError:
                                                                    includesStartDateErrors(
                                                                        schedule
                                                                    )
                                                            }">
                                                            <mat-label>From (DD/MM/YYYY)</mat-label>
                                                            <input matInput [matDatepicker]="startPicker"
                                                                [min]="minStartDate" (keydown)="
                                                                    preventInvalidKeys($event)
                                                                " formControlName="start_date"
                                                                (dateChange)="onDateChanged(i)" [disabled]="
                                                                    this.form.get([
                                                                        section.content.formName,
                                                                        i,
                                                                        'channels'
                                                                    ]).value?.length == 0
                                                                " />
                                                            <mat-datepicker-toggle matSuffix
                                                                [for]="startPicker"></mat-datepicker-toggle>
                                                            <mat-datepicker #startPicker></mat-datepicker>
                                                        </mat-form-field>
                                                        <mat-error *ngIf="
                                                                schedule.hasError('oldStartDate')
                                                            ">
                                                            Please choose a date at least 2 working
                                                            days from today
                                                        </mat-error>
                                                    </div>
                                                    <div class="col-12 col-lg-6">
                                                        <mat-form-field class="form-group dark-input" [ngClass]="{
                                                                validationError:
                                                                    includesEndDateErrors(schedule)
                                                            }">
                                                            <mat-label>To (DD/MM/YYYY)</mat-label>
                                                            <input matInput [matDatepicker]="endPicker"
                                                                formControlName="end_date" [min]="
                                                                    determineScheduleMinEndDate(
                                                                        schedule
                                                                    )
                                                                " name="end_date" (keydown)="
                                                                    preventInvalidKeys($event)
                                                                " (dateChange)="onDateChanged(i)" [disabled]="
                                                                    this.form.get([
                                                                        section.content.formName,
                                                                        i,
                                                                        'channels'
                                                                    ]).value?.length == 0
                                                                " />
                                                            <mat-datepicker-toggle matSuffix
                                                                [for]="endPicker"></mat-datepicker-toggle>

                                                            <mat-datepicker #endPicker></mat-datepicker>
                                                        </mat-form-field>
                                                        <mat-error *ngIf="
                                                                schedule.hasError('unsequencial')
                                                            ">
                                                            Date To should be after Date From
                                                        </mat-error>
                                                        <mat-error *ngIf="schedule.hasError('oldEndDate')">
                                                            End date cannot be in the past
                                                        </mat-error>
                                                    </div>
                                                </div>
                                            </div>

                                            <div appHighlight [dates]="
                                                    getScheduleDatesDirective(
                                                        i,
                                                        section.content.formName
                                                    )
                                                " [matrix]="schedule.get('matrix').value" (onTimingChanged)="
                                                    onTimingChanged(i, $event, section.previewMode)
                                                " [id]="section.content.formName + '-' + i"
                                                class="position-relative mb-4" *ngIf="
                                                    shouldScheduleAppear(
                                                        schedule,
                                                        section.content.formName,
                                                        i
                                                    )
                                                "></div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="!section.previewMode" style="gap: 10px" class="d-flex align-items-center">
                                    <a style="cursor: pointer"
                                        class="d-flex align-items-center justify-content-center text-center bg-gray-500 text-primary p-2 br-4"
                                        *ngIf="
                                            isLast &&
                                            !areAllChannelsSelected() &&
                                            section.content.formValue.length !=
                                                filterAvailableChannelsByStatus(
                                                    section.content.formName
                                                ).length
                                        " (click)="addSchedule()">
                                        Add selection
                                    </a>

                                    <a style="cursor: pointer" *ngIf="!isFirst && !previewMode"
                                        class="d-flex align-items-center justify-content-center text-center bg-gray-500 text-primary p-2 br-4"
                                        (click)="handleSelectionRemoval(i)">
                                        Remove selection
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!showChannelStatusDistinction()">
                <form [formGroup]="form">
                    <div formArrayName="schedules">
                        <div *ngFor="
                                let schedule of schedules.controls;
                                index as i;
                                first as isFirst;
                                last as isLast
                            " [formGroupName]="i" class="flex-grow-1 mx-xl-3 bg-gray-200 br-15 p-3 mb-4">
                            <app-channel-selection-field [control]="form.get(['schedules', i, 'channels'])"
                                [channels]="filterAvailableChannelsByStatus('schedules')"
                                [scheduleChannels]="getScheduleChannels(i, 'schedules')"
                                [disabledChannelIds]="getDisabledChannelIds(i, 'schedules')"
                                [disabled]="shouldDisableAllPointers" [previewMode]="previewMode"
                                (selectionChange)="onScheduleChannelsChanged(i, $event)"
                                (toggleAll)="toggleAllSelection(schedule.value, i)"
                                (remove)="removeScheduleChannel(i, $event)"
                                [customStyle]="{ width: '50%' }"></app-channel-selection-field>

                            <div style="display: flex; flex-direction: row">
                                <div style="width: 100%">
                                    <div class="bg-gray-200 br-15 py-3 mb-4" style="width: 100%">
                                        <div class="filters col-12 mb-4 border-bottom border-gray-300">
                                            <div class="row mb-4">
                                                <div class="col-12 col-lg-6 mb-3 mb-lg-0">
                                                    <mat-form-field class="form-group dark-input" [ngClass]="{
                                                            validationError:
                                                                includesStartDateErrors(schedule)
                                                        }">
                                                        <mat-label>From (DD/MM/YYYY)</mat-label>
                                                        <input matInput [matDatepicker]="startDatePicker"
                                                            [min]="minStartDate" formControlName="start_date"
                                                            (keydown)="preventInvalidKeys($event)"
                                                            (dateChange)="onDateChanged(i)" [disabled]="
                                                                this.form.get([
                                                                    'schedules',
                                                                    i,
                                                                    'channels'
                                                                ]).value?.length == 0
                                                            " />
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="startDatePicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #startDatePicker></mat-datepicker>
                                                    </mat-form-field>
                                                    <mat-error *ngIf="schedule.hasError('oldStartDate')">
                                                        Please choose a date beyond 2 working days
                                                        from today
                                                    </mat-error>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <mat-form-field class="form-group dark-input" [ngClass]="{
                                                            validationError:
                                                                includesStartDateErrors(schedule)
                                                        }">
                                                        <mat-label>To (DD/MM/YYYY)</mat-label>
                                                        <input matInput [matDatepicker]="endDatePicker"
                                                            formControlName="end_date" [min]="
                                                                determineScheduleMinEndDate(
                                                                    schedule
                                                                )
                                                            " name="end_date" (keydown)="preventInvalidKeys($event)"
                                                            (dateChange)="onDateChanged(i)" [disabled]="
                                                                this.form.get([
                                                                    'schedules',
                                                                    i,
                                                                    'channels'
                                                                ]).value?.length == 0
                                                            " />
                                                        <mat-datepicker-toggle matSuffix
                                                            [for]="endDatePicker"></mat-datepicker-toggle>

                                                        <mat-datepicker #endDatePicker></mat-datepicker>
                                                    </mat-form-field>
                                                    <mat-error *ngIf="schedule.hasError('unsequencial')">
                                                        Date To should be after Date From
                                                    </mat-error>
                                                    <mat-error *ngIf="schedule.hasError('oldEndDate')">
                                                        End date cannot be in the past
                                                    </mat-error>
                                                </div>
                                            </div>
                                        </div>

                                        <div appHighlight [dates]="getScheduleDatesDirective(i)"
                                            [matrix]="schedule.get('matrix').value"
                                            (onTimingChanged)="onTimingChanged(i, $event)" [id]="'schedule-' + i"
                                            class="position-relative mb-4"
                                            *ngIf="shouldScheduleAppear(schedule, 'schedules', i)"></div>
                                    </div>
                                </div>
                            </div>
                            <div style="gap: 10px" class="d-flex align-items-center">
                                <a style="cursor: pointer"
                                    class="d-flex align-items-center justify-content-center text-center bg-gray-500 text-primary p-2 br-4"
                                    *ngIf="
                                        isLast &&
                                        !areAllChannelsSelected() &&
                                        schedules.length != allAvailableChannels.length
                                    " (click)="addSchedule()">
                                    Add selection
                                </a>

                                <a style="cursor: pointer" *ngIf="!isFirst && !shouldDisableAllPointers"
                                    class="d-flex align-items-center justify-content-center text-center bg-gray-500 text-primary p-2 br-4"
                                    (click)="handleSelectionRemoval(i)">
                                    Remove selection
                                </a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="d-flex align-items-center justify-content-end mb-4 mx-xl-3">
                <button class="btn btn-lg btn-gray-500" *ngIf="!shouldDisableAllPointers" (click)="navigateNextStep()"
                    [disabled]="areSchedulesInvalid()">
                    proceed
                </button>
            </div>
        </div>
    </div>
</div>
